<template>
  <div class="sidebar" :class="showSidebar ? 'sidebar--showIt' : 'sidebar--showIt-no'"
    @click="$store.commit('changeModal', 'deleteOnly')">
    <div class="sidebar_logo" :style="{ backgroundColor: menuColor }">
      <a @click.prevent.stop="refresh" v-if="!$store.state.currentUser.isAdmin">
        <img class="sidebar_logo-image" :src="company.imagefull" alt v-if="!$store.getters.logo.preview">
        <img class="sidebar_logo-image" :src="$store.getters.logo.preview" alt v-else>
      </a>
      <div class="sidebar-action sidebar-action--slice" @click="eventShowIt()">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="sidebar_user" :style="{ backgroundColor: menuColor }">
      <b-dropdown class="sidebar_user__itemDrop" position="is-bottom-left" :mobile-modal="false">
        <a class="navbar-item" slot="trigger">
          <span>{{ $store.getters.currentUser.firstName }} {{ $store.getters.currentUser.lastName }} ({{ currentNamespace }})</span>
          <b-icon icon="menu-down"></b-icon>
        </a>
        <b-dropdown-item @click="setNamespace('maintenance')">Mantenimiento</b-dropdown-item>
        <b-dropdown-item @click="setNamespace('experience')">Experiencia</b-dropdown-item>
        <b-dropdown-item @click="logout">Salir</b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="sidebar_menu">
      <menu-item v-show="item.show" v-for="item in items" @setActive="onActiveItem" :active="activeMenu" :key="item.id"
        :current="currentComp" :option="item"></menu-item>
    </div>
  </div>
</template>
<script>
import MenuItem from "./../Componentes/MenuItem";
import VueLocalStorage from "vue-localstorage";
import { mapGetters } from "vuex";
export default {
  name: "Sidebar",
  components: {
    MenuItem
  },
  data() {
    return {
      activeMenu: {},
      items: [
        {
          title: "EMPRESAS",
          subitems: [],
          ruta: "businesses",
          show: this.$store.state.currentUser.isAdmin
        },
        {
          title: "USUARIOS",
          subitems: [],
          ruta: "usersMaster",
          show: this.$store.state.currentUser.isAdmin
        },
        {
          title: "DASHBOARD",
          subitems: [{ nombre: "Estado General", ruta: "dashboard" }],
          ruta: "dashboard",
          show: !this.$store.state.currentUser.isAdmin
        },
        {
          title: "PUNTO DE CONTROL",
          subitems: [],
          ruta: "puntocontrol",
          show: !this.$store.state.currentUser.isAdmin
        },
        {
          title: "ESTADÍSTICAS",
          subitems: [
            { nombre: "Puntos de control", ruta: "statistics" },
            { nombre: "Reporteadores", ruta: "statisticsReporters" }
          ],
          ruta: "statistics",
          show: !this.$store.state.currentUser.isAdmin
        },
        {
          title: "ALERTAS",
          subitems: [{ nombre: "General", ruta: "alerts-dashboard" }, { nombre: "Detalle", ruta: "alerts-list" }],
          ruta: "alerts",
          show: !this.$store.state.currentUser.isAdmin
        },
        // {
        //   title: "ALERTAS DASHBOARD",
        //   subitems: [],
        //   ruta: "alerts-dashboard",
        //   show: !this.$store.state.currentUser.isAdmin
        // },
        {
          title: "INDICADORES",
          subitems: [{ nombre: "Tareas realizadas", ruta: "tasks" }, { nombre: "Tiempo promedio vs Tareas Realizadas", ruta: "promtime" }],
          ruta: "indicator",
          show: !this.$store.state.currentUser.isAdmin
        },
        {
          title: "CONFIGURACIÓN",
          subitems: [
            { nombre: "Usuarios/Permisos", ruta: "listuser" },
            { nombre: "Direcciones/Lugares", ruta: "edificios" },
            { nombre: "Diseño general", ruta: "diseno" }
          ],
          ruta: "listuser",
          show: !this.$store.state.currentUser.isAdmin
        },
        {
          title: "DESCARGA DE HISTÓRICO",
          subitems: [],
          ruta: "download",
          show: !this.$store.state.currentUser.isAdmin
        }
      ],
      userName: "mock@app.com",
      showIt: false,
      current: {}
    };
  },
  methods: {
    onActiveItem(opt) {
      console.log(opt);
      this.activeMenu = opt;
    },
    logout() {
      this.reloading();
      this.$store.commit("resetCurrentUser");
      this.$store.commit("resetRole");
      window.localStorage.clear();
    },
    reloading() {
      this.$router.push("/");
    },
    refresh() {
      this.$router.push("/main/dashboard");
    },
    eventShowIt() {
      this.$store.commit("viewSidebar");
    },
    setNamespace($event) {
      this.$store.dispatch("SETNAMESPACE", $event);
    }
  },
  computed: {
    ...mapGetters(["company", "menuColor", "showSidebar"]),
    currentComp() {
      if (this.$route) {
        this.items.some(i => {
          if (i.subitems.length) {
            return i.subitems.some(e => {
              if (e.ruta == this.$route.meta.area) this.current = i;

              return e.ruta == this.$route.meta.area;
            });
          } else {
            if (i.ruta == this.$route.meta.area) this.current = i;
            return i.ruta == this.$route.meta.area;
          }
        });
        return this.current;
      }
    },
    currentNamespace(){
      const names = {
        maintenance: "Mantenimiento",
        experience: "Experiencia"
      }
      return names[this.$store.state.namespace]
    }
  }
};
</script>

<style lang="scss">
// @import "./../../assets/styles/2.tools/mixins/_navegators.scss";
@import "../../assets/styles/2.tools/mixins/_mediaquerys.scss";

.sidebar {
  // width: 550px;
  position: fixed;

  &--showIt-no {
    // left: -380px;
    transition: all 0.5s ease;
  }

  &--showIt {
    transition: all 0.5s ease;
    left: 0;
  }

  left: -380px;
  z-index: 200;
  border-right: 1px solid #b8c0d0;
  top: 0;
  bottom: 0;
  overflow: auto;
  @include media-xl {
    left: 0;
    border-right: none;
    box-shadow: 3px 0px 15px 0 #b8c0d0;
    z-index: 100;
  }

  min-width: 300px;
  max-width: 330px;
  height: 100%;
  font-family: "Roboto";
}

.sidebar {
  background-color: #fafafa;

  .sidebar_logo {
    margin-top: 42px;
    background-color: #f5f5f5;

    @include media-xl {
      margin-top: 0;
    }
  }

  .sidebar_user {
    background-color: #f5f5f5;
  }
}

.sidebar_logo {
  // height: 135px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sidebar_logo-image {
  height: 120px;
  width: 360px;
  margin: auto;
}

.sidebar_user {
  height: 45px;
  width: 100%;
  display: flex;
  justify-content: space-around;

  &__itemDrop {
    width: 100%;

    .dropdown-menu {
      padding-top: 0;
    }

    .dropdown-trigger {
      width: 100% !important;
    }
  }

  // .is-mobile-modal {
  //   width: 100% !important;
  //   .dropdown-trigger {
  //     width: 100% !important;
  //   }

  //   // padding-left: 25px;
  //   .navbar-item {
  //     padding-left: 27px;
  //     padding-right: 24px;
  //     width: 100%;
  //   }
  // }
}

// .sidebar_user-menu_btn {
//   background-color: grey;
// }
// .sidebar_user-menu-bp__body {
//   background-color: lightgray;
// }
// .sidebar_user-menu-list {
//   list-style-type: none;
//   margin: 0px;
//   padding: 0px;
//   display: flex;
//   justify-content: flex-start;
//   align-items: center;
//   flex-flow: row wrap;
//   width: 100px;
//   background-color: inherit;
// }

.navbar-item {
  font-family: "Roboto";
  display: flex;
  justify-content: space-between;
  padding-left: 27px;
  padding-right: 24px;
  font-weight: 700;
  width: 100%;

  &:visited {
    color: #040404;
    text-decoration: none;
  }

  &:hover {
    color: #040404 !important;
    background-color: transparent !important;
  }

  span {
    color: #000;
  }

  .icon {
    position: relative;
    left: 5px;
  }
}

.dropdown-content {
  transition: 0.5s all;

  .dropdown-item {
    padding: 1rem !important;
    font-weight: bold;
    background-color: #ffffff;
    &:visited {
      color: #040404;
      text-decoration: none;
    }

    &:hover {
      color: #1fb6ff !important;
      background-color: #efefef !important;
    }
  }
}

.sidebar-action {
  &--slice {
    position: absolute;
    top: 10px;
    right: 0;
    margin-right: 10px;

    @include media-xl {
      display: none;
    }

    i {
      color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/Sidebar.vue